<template>
  <a-modal
    v-model:open="isOpen"
    centered
    :width="400"
    class="lk-mobile-notice-modal"
    :footer="null"
    :closable="true"
    :mask-closable="true"
    :keyboard="true"
    @cancel="close"
  >
    <p class="lk-mobile-notice-modal__text">
      Для удобства работы в личном кабинете просим воспользоваться веб-версией портала
    </p>

    <div class="lk-mobile-notice-modal__actions">
      <button type="button" class="btn btn-primary btn-medium" @click="close">ОК</button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

const MOBILE_QUERY = '(max-width: 992px)';

const isOpen = ref(false);

const close = (): void => {
  isOpen.value = false;
};

const scrollModalIntoView = (): void => {
  requestAnimationFrame(() => {
    document.querySelector('.lk-mobile-notice-modal')?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  });
};

onMounted(async () => {
  if (!window.matchMedia(MOBILE_QUERY).matches) return;

  isOpen.value = true;
  await nextTick();
  scrollModalIntoView();
});
</script>

<style lang="scss">
.lk-mobile-notice-modal {
  .ant-modal-content {
    padding: 32px 32px 28px;
    border-radius: 12px;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .ant-modal-close {
    top: 16px;
    inset-inline-end: 16px;
  }
}

.lk-mobile-notice-modal__text {
  margin: 0;
  padding-right: 24px;
  font-family: var(--stc-font-medium), sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 160%;
  color: var(--stc-black);
}

.lk-mobile-notice-modal__actions {
  display: flex;
  justify-content: flex-end;
}

.lk-mobile-notice-modal__actions .btn {
  min-width: 96px;
}
</style>
